import {useNavigate} from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import AuthHistory from "../Container/AuthHistory";
import PatientHeader from "../../PatientHeader/containers/index";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { BackBtn, HeaderText } from "../../PatientHeader/style";

const PatientDetails = () => {
  const navigate = useNavigate();
   const handleBackOp = () => {
     navigate(-1);
  };
  return (
    <Grid container m={"1rem 2rem"}>
      <Grid size={12}>
        <Box display="flex" alignItems={"center"}>
          <Button
            variant="contained"
            sx={BackBtn}
            onClick={handleBackOp}
            data-testid="auth-details-back-button"
          >
            BACK
          </Button>
          <Typography
            variant="h4"
            fontWeight={fontWeight.Weight[6]}
            color={colors.black[2]}
            sx={HeaderText}
          >
            PATIENT DETAILS
          </Typography>
        </Box>
        <PatientHeader />
      </Grid>
      <Grid size={12}>
        <AuthHistory />
      </Grid>
    </Grid>
  );
};

export default PatientDetails;
